import moment from "moment/moment";
import { POST, PUT, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaPersonalTransportar(combo = false) {
    try {
        let rows = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/personal-transportar/obtener-lista-personal-transportar/",
            {
                headers: getHeaders(),
                method: POST,
                // body: JSON.stringify({data: 'hello'}),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            if (combo === true) {
                for (let i = 0; i < body.length; i++) {
                    const element = body[i];
                    let obj = {};
                    obj.value = element.id;
                    obj.label = element.descripcion;
                    rows.push(obj);
                }
            }
            if (combo === false) {
                for (let i = 0; i < body.length; i++) {
                    body[i].fechaProceso = moment(body[i].fechaProceso).format('DD/MM/YYYY HH:mm')
                    rows.push(body[i]);
                }
            }
        }
        return rows;
    } catch (err) {
        console.log("obtenerListaPersonalTransportar err");
        console.log(err);
        return [];
    }
}

export async function crearPersonalTransportar(obj) {
    try {
        let creado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/personal-transportar/guardar-personal-transportar",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            creado = true;
        }
        return creado;
    } catch (err) {
        console.log("crearPersonalTransportar err");
        console.log(err);
        return false;
    }
}

export async function modificarPersonalTransportar(obj) {
    try {
        let modificado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/personal-transportar/modificar-personal-transportar",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            modificado = true;
        }
        return modificado;
    } catch (err) {
        console.log("modificarPersonalTransportar err");
        console.log(err);
        return false;
    }
}

export async function deshabilitarPersonalTransportar(obj) {
    try {
        let result = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/personal-transportar/deshabilitar-personal-transportar",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            result = true;
        }
        return result;
    } catch (err) {
        console.log("deshabilitarPersonalTransportar err");
        console.log(err);
        return false;
    }
}
